/**
 * isSubscribeInEntitlementPath - Returns a boolean value if the path is an exact subscribe math
 *
 * @param {string} path - String representing the entitlementPath
 *
 * @return {boolean} - Returns true or false
 */
export default (path = '') => (typeof path === 'string' && path.trim().toLowerCase() === 'subscribe');



// WEBPACK FOOTER //
// ./app/webapp/page/Activate/util/isSubscribeInEntitlementPath.js